import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../service/components/loading.service';

/**
 * Componente que muestra un spinner de carga global durante operaciones asíncronas
 */
@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loadingService.loading$ | async) {
    <div class="spinner-overlay">
      <div class="spinner-container slide-in-top">
        <div class="loader">
          <div class="square square-1"></div>
          <div class="square square-2"></div>
          <div class="square square-3"></div>
        </div>
      </div>
    </div>
    }
  `,
  styles: `
    .spinner-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--bg-fifth);
      animation: fadeIn 0.2s ease-out;
      backdrop-filter: blur(4px);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .spinner-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .loader {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    .square {
      width: 20px;
      height: 20px;
      border-radius: 2px;
      background: var(--color-loader);
      box-shadow: 0 0 0 rgba(0, 255, 255, 0);
      animation: activate 2s infinite;
      transition: all 0.2s ease;
    }
    
    .square-1 {
      animation-delay: 0s;
    }
    
    .square-2 {
      animation-delay: 0.5s;
    }
    
    .square-3 {
      animation-delay: 1s;
    }
    
    .square-4 {
      animation-delay: 1.5s;
    }

    .slide-in-top {
      animation: slide-in-top 0.5s ease-out;
    }


    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes slide-in-top {
      from {  
        transform: translateY(-100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes activate {
      0%, 75%, 100% {
        background: var(--color-loader);
        box-shadow: 0 0 0 rgba(0, 255, 255, 0);
        transform: scale(0.9);
      }
      25%, 50% {
        background: var(--color-loader);
        box-shadow: 0 0 20px rgba(176, 255, 248, 0.8);
        transform: scale(1.1);
      }
    }
  `,
})
export class SpinnerComponent {
  /**
   * Constructor del componente
   * @param loadingService Servicio que controla la visibilidad del spinner
   */
  constructor(public loadingService: LoadingService) {}
}
